import { render, staticRenderFns } from "./EntitySelect.vue?vue&type=template&id=19c7794e&"
import script from "./EntitySelect.vue?vue&type=script&lang=ts&"
export * from "./EntitySelect.vue?vue&type=script&lang=ts&"
import style0 from "./EntitySelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VAutocomplete,VChip,VDialog})
